import { Link, NavLink, useNavigate } from "react-router-dom";
import classes from "./Header.module.css";
import logo from "../images/DCL.jpg";
import { Fragment, useState } from "react";
import { useContext } from "react";
import { CartContext } from "../../CartContext";
import MenuIcon from "./menuIcon";
import Flip from "react-reveal/Flip";
import { FiX } from "react-icons/fi";

const Header = (props) => {
  const navigate = useNavigate();
  const context = useContext(CartContext);
  const [openMenu, setOpenMenu] = useState(false);
  const [modal, setModal] = useState(false);

  const isLoggedIn = context.isLoggedIn;

  const toggleMenu = () => {
    setOpenMenu(true);
    setModal(true);
  };
  const closeMenu = () => {
    setOpenMenu(false);
    setModal(false);
  };

  const logoutHandler = () => {
    context.logout();
  };
  return (
    <Fragment>
      {modal && <div className="backdrop" />}
      <header className={classes.header}>
        <Flip left>
          <Link to="/">
            <img src={logo} />
          </Link>
        </Flip>
        <button className={classes.btn} onClick={toggleMenu}>
          <MenuIcon />
        </button>
        {isLoggedIn && (
          <button className={classes.logout} onClick={logoutHandler}>
            Logout
          </button>
        )}
        <nav className={classes.nave}>
          <Flip left>
            <ul>
              <li>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? classes.active : classes.link
                  }
                  to="/home"
                >
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? classes.active : classes.link
                  }
                  to="/store"
                >
                  Store
                </NavLink>
              </li>

              {!isLoggedIn && (
                <li>
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? classes.active : classes.link
                    }
                    to="/register"
                  >
                    Sign Up
                  </NavLink>
                </li>
              )}

              {!isLoggedIn && (
                <li>
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? classes.active : classes.link
                    }
                    to="/login"
                  >
                    Sign In
                  </NavLink>
                </li>
              )}
            </ul>
          </Flip>
        </nav>

        {openMenu && (
          <nav className={classes.nav1}>
            <ul>
              <li>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? classes.active1 : classes.link1
                  }
                  to="/home"
                >
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? classes.active1 : classes.link1
                  }
                  to="/store"
                >
                  Store
                </NavLink>
              </li>

              {isLoggedIn && (
                <li>
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? classes.active1 : classes.link1
                    }
                    to="/profile"
                  >
                    Profile
                  </NavLink>
                </li>
              )}

              {!isLoggedIn && (
                <li>
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? classes.active1 : classes.link1
                    }
                    to="/register"
                  >
                    Sign Up
                  </NavLink>
                </li>
              )}
              {!isLoggedIn && (
                <li>
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? classes.active1 : classes.link1
                    }
                    to="/login"
                  >
                    Sign In
                  </NavLink>
                </li>
              )}
            </ul>
            {isLoggedIn && (
              <button className={classes.logouts} onClick={logoutHandler}>
                Logout
              </button>
            )}
            <div className={classes.socials}>
              <a target="blank" href="https://www.facebook.com/DCluxurious">
                <i class="fa-brands fa-facebook"></i>
              </a>
              <a
                target="blank"
                href="https://instagram.com/dc_luxurious?igshid=YmMyMTA2M2Y="
              >
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a href="https://wa.me/2348144278102" target="blank">
                <i class="fa-brands fa-whatsapp"></i>
              </a>
              <a
                href="https://twitter.com/Dc_luxurious?t=Zm2nqFXZJUnkdrw-_x7B3w&s=09"
                target="blank"
              >
                <i class="fa-brands fa-twitter"></i>
              </a>
            </div>
            <button onClick={closeMenu}>
              <span>
                <FiX />
              </span>
            </button>
          </nav>
        )}
      </header>
    </Fragment>
  );
};

export default Header;
